module.exports = __webpack_public_path__ + "static/img/3.8c4f0a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3.png
// module id = 2KZP
// module chunks = 0